import { PATH_API } from "constants/api";
import { ApiResponse, Pagination } from "interfaces/models/api";
import { DocumentPageLayout } from "interfaces/models/documentPageLayout";
import { axiosECS } from "services/baseAxios";

interface GetPageLayoutReq extends Pagination {
  documentFormatId: string;
}

const pathV2 = PATH_API.DOCUMENT_PAGE_LAYOUT;


export const getPageLayout = async (id: string): Promise<ApiResponse> => {
  return axiosECS.get(`${pathV2}/${id}`);
};

export const deletePageLayout = async (
  id: string
): Promise<ApiResponse<string[]>> => {
  return axiosECS.delete(pathV2, { data: { id } });
};


/**
 * @deprecated
 */
export const getPageLayoutList = async (
  params: GetPageLayoutReq
): Promise<ApiResponse<DocumentPageLayout[]>> => {
  return axiosECS.get(pathV2, {
    params,
  });
};

/**
 * @deprecated
 */
export const createUpdateMultiPageLayout = async (body: {
  pageLayouts: DocumentPageLayout[];
  documentFormatId: string;
}): Promise<ApiResponse<DocumentPageLayout[]>> => {
  return axiosECS.post(`${pathV2}/bulk`, body);
};
